import React from 'react';
import { withNamespaces } from 'react-i18next';

class Citoyen extends React.Component {
    render() {
        return (
            <div className="homePageContainer">
                <div className="homeText">
                    <div className="homeTextInnerWrapper">
                        <div className="homeTextInner">
                            <div className="homeTextActualText">
                            <h2>Collège Citoyen</h2>
                                <div className="detailsHeader">
                                <div className="subBlock1">
                                    
                                    <h3>{this.props.t("Statistics")}</h3>
                                    <p>{this.props.t("Number of teachers")} 24</p>
                                    <p>{this.props.t("Number of students")} 440</p>
                                    <p>{this.props.t("International students")} 1%</p>
                                    <p>{this.props.t("School uniform")} {this.props.t("Required")} </p>
                                    <p>{this.props.t("Grades")} {this.props.t("7-11")}</p>
                                    <p>{this.props.t("Founded")} 2011, {this.props.t("expanded")} 2016</p>
                                </div>
                                <div className="subBlock2">
                                <img src="/images/citoyen1.jpg" alt="city" />
                                <img src="/images/citoyen2.jpg" alt="city" />
                                </div>
                                </div>

                                <div className="schoolDetailsBlock">
                                    <h2>{this.props.t("Programs")}</h2>
                                    <span>{this.props.t("Enriched academic programs,  Leadership entrepreneurial program, drama, art, science et technology – robotics,  math, history, etc")}</span>
                                </div>
                                <div className="schoolDetailsBlock">
                                    <h2>{this.props.t("Sports Activities")}</h2>
                                    <span>{this.props.t("Golf, Tennis, horseriding, Volleyball, basketball, cheerleading, Outdoor education, Intramural sports, etc")}</span>
                                </div>
                                <div className="schoolDetailsBlock">
                                    <h2>{this.props.t("Club Activities")}</h2>
                                    <span>{this.props.t("Chess, Robotics, student council, multi-media, choir,  and improv clubs, environment club, young commited citizens coop club, etc.")}</span>
                                </div>
           
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withNamespaces()(Citoyen);